import { Router,NavigationExtras } from '@angular/router';
import { LoaderService } from './../loder_service/loader.service';
import { Storage } from '@ionic/storage';
import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.scss'],
})
export class WishlistComponent implements OnInit {
  wishlist_array:any;
  constructor(public router:Router, public storage:Storage,public restApi:DataService, public toastService:LoaderService) { }

  ngOnInit() {}
ionViewWillEnter(){
  this.toastService.showLoader('')
  
    let postparams={
      usersessionId:localStorage.getItem('user_id')
     }
     this.restApi.my_wish_list(postparams).subscribe((data:any)=>{
       this.wishlist_array=data.wishlist_array;
       console.log(this.wishlist_array.length);
       if(this.wishlist_array.length==0){
         this.toastService.create('Your Wishlist is currently empty')
       }
       
      this.toastService.hideLoader()
     },(error:any)=>{
      this.toastService.hideLoader()
     })
  
 

}
goto_product_details(item){
  let product_id=item.pro_id
  let navigationExtras: NavigationExtras = {
    queryParams: {
      product_id: JSON.stringify(product_id),
    }
  };
  console.log(item.product_id);
  //routerLink="/productdetails"
  this.router.navigate(['/productdetails'], navigationExtras); 
}
delete_wish(id){
  console.log(id);
this.toastService.showLoader('')
let postparams={
  wishid:id
}
this.restApi.delete_wish_list(postparams).subscribe((data:any)=>{
this.toastService.hideLoader()
this.toastService.create('Successfully deleted')
this.ionViewWillEnter();
},(error:any)=>{
  this.toastService.hideLoader()
})
  
}
}
